import React from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap'

export default function ItemPassage (props) {
  return (
    <Card>
      <CardHeader>
        Passage
      </CardHeader>
      <CardBody>
        <div dangerouslySetInnerHTML={{__html: props.passage}} /> 
      </CardBody>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentItemView/ItemPassage.js